import React, { useState, useEffect, useMemo } from "react";
import { Layout, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./app-header.scss";
import { useStore } from "../../store/store";
import { CommonConstants, AccessFields } from "../../constants/commonConstants";
import * as lokalizeService from "../../service/lokalizeService";
import { LocalStorageKeys } from "../../constants/localStorageKeys";
import * as localStorageService from "../../service/localStorageService";
import HelpCircle from "../../assets/images/help-circle.svg";
import NextArrow from "../../assets/images/sidebar-rightArrow.svg";
import NextWhiteArrow from "../../assets/images/NextArrowQuiteHours.png";
import backArrow from "../../assets/images/arrow-left-go- back.svg";
import notification from "../../service/notification";
import { GuestWarningModal } from "../guest-warning-modal";
import { checkIsInternalSourcing } from "../../util/constantUtility";
import helpCircle from "../../assets/images/help-circle.png";
import moonImg from "../../assets/images/moon.png";



const { Header } = Layout;

const AppHeader = ({ isWait, onChange }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [projectLanguages, setProjectLanguages] = useState([]);
  const [selectedProjectLanguage, setSelectedProjectLanguage] = useState(CommonConstants.DefaultLanguageCode);
  const [selectedProjectLanguageLabel, setSelectedProjectLanguageLabel] = useState(CommonConstants.DefaultLanguageName);
  let { name } = useParams();
  let isGuest = localStorageService.getValue("guestMode") === "true";
  const { user, saveUser } = useStore();
  const invoiceDateRange = localStorageService.getValue("invoiceDateRange");

  // Navigation titles
  const navTitleList = useMemo(() => [
    { title: t("LEFT_SIDER_HOME"), key: "/home" },
    { title: t("LEFT_SIDER_LOADS"), key: "/loads" },
    { title: t("LEFT_SIDER_MY_BIDS"), key: "/my-bids" },
    { title: t("LEFT_SIDER_MY_BIDS_SUBMIT"), key: "/my-bids/submissions" },
    { title: t("LEFT_SIDER_MY_BIDS_AWARD"), key: "/my-bids/awarded" },
    { title: t("LEFT_SIDER_ORDERS"), key: "/orders" },
    { title: t("LEFT_SIDER_FLEET_MANAGEMENT"), key: "/view-fleet" },
    { title: t("LEFT_SIDER_EARNINGS"), key: "/earnings" },
    { title: t("LEFT_SIDER_NOTIFICATIONS"), key: "/notifications" },
    { title: t("LEFT_SIDER_SETTINGS"), key: "/setting" },
    { title: t("ACCOUNT_DETAILS"), key: "/account" },
    { title: t("LEFT_SIDER_FULFILMENT"), key: "/fulfilments" },
    { title: t("LEFT_SIDER_HELP_AND_SUPPORT"), key: "/helpAndSupport" },
  ], [t]);
  

  // Take proper path extraction
  const cleanPathname = location.pathname.replace(/^#/, "");

  // Split the path into segments
  let pathSegments = cleanPathname.split("/").filter(Boolean);

  // Extract the last segment and check if it's valid name
  let lastSegment = pathSegments[pathSegments.length - 1];

  let hasValidName = name && decodeURIComponent(lastSegment) === name;

  if (hasValidName) {
    if (name.includes('-')) {
      const parts = decodeURIComponent(name).split('-');
     if (parts.length === 2) {
        if(parts[1] === "null"){
          pathSegments[pathSegments.length - 1] = `${parts[0]}`;
        }
        else{
          pathSegments[pathSegments.length - 1] = `${parts[0]} (${parts[1]})`;
        }
      } 
      else {
        pathSegments[pathSegments.length - 1] = decodeURIComponent(name);
      }
    } 
    else {
      pathSegments[pathSegments.length - 1] = decodeURIComponent(name);
    }

    //change the path segments for fleet management
    if(cleanPathname.startsWith('/fleet-management') && pathSegments.length > 2){
      pathSegments = [pathSegments[0], pathSegments[pathSegments.length - 1]];
    }
    else{
      pathSegments.splice(pathSegments.length - 2, 1);
    }
  }

  const filteredSegments = pathSegments.filter(segment => segment !== "undefined");

  let accumulatedPath = "";
  const breadcrumb = filteredSegments.map((segment, index) => {
    let matchedItem = "";
    // if(segment==="supplier-detail"){
    //   accumulatedPath += `/view-fleet`;
    // }
    // else{
      accumulatedPath += `/${segment}`;
      matchedItem=navTitleList.find((item) => item.key === accumulatedPath)
    // }
      
      return matchedItem
        ? { title: matchedItem.title, key: accumulatedPath }
        : { title: segment, key: accumulatedPath };
  });
  
  // Fetch project languages
  useEffect(() => {
    setUpProjectLanguage();
  }, []);

  const setUpProjectLanguage = async () => {
    try {
      const res = await lokalizeService.getAllLanguage();
      const languages = res.data.Data.map((item) => ({
        key: item.LanguageISOCode,
        label: item.LanguageName,
        value: item.LanguageISOCode,
      }));
      setProjectLanguages(languages);

      const savedLang = localStorageService.getValue(LocalStorageKeys.Lang);
      if (savedLang) {
        const language = languages.find((lang) => lang.key === savedLang);
        if (language) {
          setSelectedProjectLanguage(savedLang);
          setSelectedProjectLanguageLabel(language.label);
        }
      }
    } catch (error) {
      
    }
  };

  const handleLanguageChange = (e) => {
    const selectedLang = projectLanguages.find((lang) => lang.key === e.key);
    if (selectedLang) {
      setSelectedProjectLanguage(e.key);
      setSelectedProjectLanguageLabel(selectedLang.label);
      onChange(e.key);
    }
  };

  const helpHandler = () =>{
    if(isGuest){
      GuestWarningModal(navigate,t)
    }
    else{
      if(location.pathname === "/earnings/invoice-upload" || location.pathname === "/earnings/add-new-invoice"){
        navigate("helpAndSupport", {
          state: {
            fromDate:invoiceDateRange.fromDate ? invoiceDateRange.fromDate:null,
            toDate: invoiceDateRange.toDate ? invoiceDateRange.toDate:null,
            selectedItem: "Invoice"
          },
        });
      }else{
          navigate("helpAndSupport");
      }
      
    }
  }

  return (
    // <Header  className="app-header-wrapper">
<Header className={`app-header-wrapper ${user?.isQuietHour===true && (location.pathname === "/loads" || location.pathname === "/my-bids/submissions" || location.pathname === "/my-bids/awarded") ? "loads-header" : ""}`}>

      <div className="app-header-container1" style={{marginRight:'20px'}}>
        {breadcrumb.length > 0 && (
          breadcrumb.some(item => item.key.startsWith("/supplier-fleet")) ? (
            // If path starts with "/supplier-fleet", show "Go back"
            <span key="go-back" className="Title-inactive" onClick={() => navigate(-1)}>
              <img src={backArrow} alt=''  loading="lazy" /> {t("GO_BACK_BTN")}
            </span>
          ) : (
            breadcrumb.map((item, index) => {
              const isLast = index === breadcrumb.length - 1;
              const isMyBids = item.key === "/my-bids";
              const isFleetManagement = item.key.startsWith("/fleet-management");
              const isSupplier = item.key.startsWith("/supplier-detail");
              const orderDetails=item.title === "orderDetails";

              return (
                  <React.Fragment key={item.key}>
                    {index > 0 && <img src={(user?.isQuietHour===true && (item.key==="/my-bids/submissions" || item.key==="/my-bids/awarded")) ? NextWhiteArrow : NextArrow } alt="Next" className="next-arrow-icon"  loading="lazy" />}

                    {isMyBids ? (
                      <span className="Title-inactive"
                        onClick={() => {
                          const latestPage = breadcrumb.find((val) => ["/my-bids/submissions", "/my-bids/awarded"].includes(val.key) );
                            if (latestPage) { 
                              navigate(latestPage.key);
                            }
                        }}
                      >
                        {item.title}
                      </span>
                    ) : (
                        <span className={isLast && index > 0 ? "Title-active non-clickable" : isLast && index === 0 ? "Title-active-first non-clickable" : "Title-inactive"}
                          onClick={() => {
                            if (!isLast && !isFleetManagement && !isSupplier && !orderDetails) {
                              navigate(item.key);
                              return;
                            }
                            if (breadcrumb.length !== 1) {
                              if (item.key.includes("/my-bids") && breadcrumb.length === 2) {
                                return;
                              }
                              else if (isFleetManagement || isSupplier) {
                                window.history.back();
                                return;
                              } 
                              else if (isLast && !isFleetManagement) {
                                  navigate(-1);
                              } else if(orderDetails){
                                return;
                              }
                              else {
                                  navigate(item.key);
                              }
                            }
                          }}
                        >
                          {item.title === t("LEFT_SIDER_MY_BIDS_SUBMIT") ? t("MY_BIDS_SUBMISSIONS")
                          : item.title === t("LEFT_SIDER_MY_BIDS_AWARD") ? t("MY_BIDS_AWARDED")
                          : item.title === 'fulfilments' ? t("LEFT_SIDER_FULFILMENT")
                          : item.title === 'orderDetails' ? t("EARNING_TXN_ORDER_DETAILS_CRUM")
                          : item.title === 'add-new-invoice' ? t("INV_UPLOAD_ADD_NEW_INV_CRUM")
                          : item.title === 'invoice-upload' ? t("INV_UPLOAD_HEADING_CRUM")
                          : item.title
                          }
                        </span>
                    )}
                  </React.Fragment>
            )})
          )
          )}
          
{user?.isQuietHour===true && (location.pathname === "/loads" || location.pathname === "/my-bids/submissions" || location.pathname === "/my-bids/awarded") && 
<div className="quite-hours-div">
  <img src={moonImg}/>
  <span>Quite Hours</span>
</div>
}
      </div>


      {user?.isQuietHour===true && (location.pathname === "/loads" || location.pathname === "/my-bids/submissions" || location.pathname === "/my-bids/awarded") && checkIsInternalSourcing(user?.userRole) && 
    //    <div className="need-help-support">
    //    <img src={helpCircle}/>
    //    <span> Need Help </span>
    //  </div>
    <Button  onClick={() => helpHandler()} className="need-help-support">
        <img style={{height:'16px'}} src={helpCircle} alt=''  loading="lazy"/>{t("COMMON_NEED_HELP_BTN")}
      </Button>
      }
     
      
      
{    !checkIsInternalSourcing(user?.userRole) &&  <Button  onClick={() => helpHandler()} className="button-help-support">
        {/* <img src={HelpCircle} alt=''  loading="lazy"/>{t("COMMON_NEED_HELP_BTN")} */}
          <img style={{height:'16px'}} src={user?.isQuietHour===true && (location.pathname === "/loads" || location.pathname === "/my-bids/submissions" || location.pathname === "/my-bids/awarded") ?  helpCircle: HelpCircle} alt=''  loading="lazy"/>{t("COMMON_NEED_HELP_BTN")}

      </Button>}
    </Header>
  );
};

export default AppHeader;
